export function noMeta(meta) {
    return meta.ctrlKey === false && meta.altKey === false && meta.shiftKey === false;
}
